import {Condition} from '@legit-health/ui';
import {Autocomplete, ListItem, ListItemAvatar, TextField} from '@mui/material';
import {TFunction} from 'i18next';
import ConditionAvatar from './ConditionAvatar';
import ConditionSelectItem from './ConditionSelectItem';

export default function ConditionSelector({
  selectedConditionId,
  conditions,
  onSelectCondition,
  t
}: {
  selectedConditionId: string | null;
  conditions: Condition[];
  onSelectCondition: (conditionId: string | null) => void;
  t: TFunction;
}) {
  const selectedOption = conditions.find(
    (conditions) => `${conditions.id}` === selectedConditionId
  );

  return (
    <Autocomplete
      options={conditions}
      onChange={(_: any, newValue) => {
        onSelectCondition(newValue ? `${newValue.id}` : null);
      }}
      value={selectedOption ?? null}
      getOptionLabel={(option) =>
        t('shared/common:condition', {
          pathology: option.pathology.name,
          bodySite: option.bodySite.name.toLowerCase()
        })
      }
      renderOption={(props, option) => {
        return (
          <ConditionSelectItem key={option.id} condition={option as Condition} liProps={props} />
        );
      }}
      renderInput={(params) => (
        <ListItem disablePadding>
          {selectedOption && (
            <ListItemAvatar>
              <ConditionAvatar condition={selectedOption} />
            </ListItemAvatar>
          )}
          <TextField {...params} label={t('shared/common:selectPathology')} />
        </ListItem>
      )}
    />
  );
}
